import moment from "moment"

const INITIAL_STATE = {
  logs: {
    data: []
  },
  admins: [],
  pessoas: [],
  tipos: [],
  dadosFiltro: {
    id: '',
    data: '',
    horarioDe: '',
    horarioAte: '',
    usuario: { label: 'selecione o usuário', value: '' },
    setor: { label: 'selecione o setor', value: '' },
    funcao: { label: 'selecione a função', value: '' },
    funcionario: { label: 'selecione o funcionario', value: '' },
    tipo: { label: 'selecione o tipo', value: '' },
    clear: false
  }
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'ADMIN_LOG_FETCH': {
      let copyLogs = { ...state.logs }
      copyLogs = action.payload

      return { ...state, logs: copyLogs }
    }
    case 'ADMIN_PESSOAS_FETCH': {
      let copyLogs = [...state.pessoas]
      copyLogs = action.payload

      return { ...state, pessoas: copyLogs }
    }
    case 'ADMIN_USUARIOS_FETCH': {
      let copyLogs = [...state.admins]
      copyLogs = action.payload

      return { ...state, admins: copyLogs }
    }
    case 'ADMIN_LOG_TIPOS_FETCH': {
      let copyTipos = [...state.tipos]
      copyTipos = action.payload

      return { ...state, tipos: copyTipos }
    }
    case 'ADMIN_LOG_SET_FILTRO': {
      const dadosFiltroCopy = { ...state.dadosFiltro }
      dadosFiltroCopy[action.campo] = action.valor
      return { ...state, dadosFiltro: dadosFiltroCopy }
    }
    case 'ADMIN_LOG_SET_FILTRO_CLEAR': {
      const dadosFiltroCopy = {
        id: '',
        data: '',
        horarioDe: '',
        horarioAte: '',
        usuario: { label: 'selecione o usuário', value: '' },
        setor: { label: 'selecione o setor', value: '' },
        funcionario: { label: 'selecione o funcionario', value: '' },
        funcao: { label: 'selecione a função', value: '' },
        tipo: { label: 'selecione o tipo', value: '' },
        clear: false
      }
      return { ...state, dadosFiltro: dadosFiltroCopy }
    }
    default:
      return state
  }
}